import React from "react";
import styled from "styled-components";

import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSRgBody02 from "../../molecules/text/linSeedKr/Rg/lsRgBody02";
import useDisplay from "../../../hooks/useDisplay";

const SelecteBoxValue = ({
  style,
  subMenuStyle,
  isMiddle,
  isOpen,
  wrapperHandler,
  selectedValue,
  placeholder,
  selectedValueSetterFunc,
  itemList,
  disabled,
}) => {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        ...style,
      }}
    >
      <SelectBoxWrapper
        $isSmall={isSmall}
        onClick={() => {
          if (disabled) {
            return;
          }

          wrapperHandler(!isOpen);
        }}
        style={{
          cursor: "pointer",
        }}
      >
        <LSRgH1HeadLine
          style={{
            color: selectedValue ? "#000000" : "#A4A8B1",
            fontSize: isMobile ? 15 : 16,
            lineHeight: isMobile ? "21px" : "22.4px",
          }}
        >
          {selectedValue
            ? itemList.find((item) => item.value === selectedValue)?.title
            : placeholder}
        </LSRgH1HeadLine>
        <img
          className={isOpen ? "rotate" : "rotate-back"}
          style={{
            width: 20,
            height: 22,
          }}
          src="/assets/icons/selectbox_arrow.png"
          alt="펼치기"
        />
      </SelectBoxWrapper>
      {isOpen ? (
        <SubMenuWrapper
          isMiddle={isMiddle}
          className="custom-scrollbar"
          style={{
            ...subMenuStyle,
          }}
        >
          {itemList.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  borderRadius: 3,
                  height: "41px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "10px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  selectedValueSetterFunc(item.value);
                  wrapperHandler(false);
                }}
              >
                <LSRgBody02
                  style={{
                    color: selectedValue === item.value ? "#000000" : "#808991",
                  }}
                >
                  {item.title}
                </LSRgBody02>
                {selectedValue === item.value ? (
                  <img
                    style={{
                      width: "18px",
                      height: "18px",
                    }}
                    src="/assets/icons/selectbox_checked.png"
                    alt=""
                  />
                ) : null}
              </div>
            );
          })}
        </SubMenuWrapper>
      ) : null}
    </div>
  );
};

export default SelecteBoxValue;

const SelectBoxWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: ${(props) => (props.$isSmall ? "48px" : "56px")};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  border-radius: 12px;
  border: 1px solid #dbdde0;
  background: #fff;
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  min-height: 56px;
  max-height: 225px;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 66px;
  right: 0;
  padding: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 5;
`;
